import React, { useState, useEffect } from 'react';
import { Box, Typography, Table, TableBody, TableCell, TableHead, TableRow, Grid } from '@mui/material';
import { db } from '../../firebase';
import { doc, getDoc } from 'firebase/firestore';
import { formatDate } from '../../utils/formatters';

const TechnicalServiceForm = ({ data }) => {
    const [settings, setSettings] = useState(null);
    const [deviceInfo, setDeviceInfo] = useState(null);

    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const docSnap = await getDoc(doc(db, "settings", "company_info"));
                if (docSnap.exists()) {
                    setSettings(docSnap.data());
                }
            } catch (error) {
                console.error("Firma bilgileri yüklenemedi:", error);
            }
        };
        fetchSettings();
    }, []);

    useEffect(() => {
        const fetchDevice = async () => {
            if (data?.serviceRecord?.cihazId) {
                try {
                    const devSnap = await getDoc(doc(db, "devices", data.serviceRecord.cihazId));
                    if (devSnap.exists()) {
                        setDeviceInfo(devSnap.data());
                    }
                } catch (e) { console.error("Cihaz bilgisi çekilemedi", e); }
            }
        };
        fetchDevice();
    }, [data?.serviceRecord?.cihazId]);

    if (!data || !data.serviceRecord) return null;

    const { serviceRecord, customer } = data;

    const companyName = settings?.firmaAdi || "RESLIFE MEDİKAL";
    const subTitle1 = settings?.altBaslik1 || "Uyku ve Solunum Cihazları";
    const subTitle2 = settings?.altBaslik2 || "TIBBI CİHAZLAR SANAYİ VE TİC. LTD.ŞTİ";
    const address = settings?.adres || "Adres: Örnek Mah. Örnek Sok. No:1, İstanbul";
    const phone = settings?.telefon || "Tel: 0212 123 45 67";
    const web = settings?.web || "Web: www.reslife.com.tr";
    const logoUrl = settings?.logoUrl || "/reslife-logo.png";
    const bankName = settings?.bankaAdi || "Örnek Bankası / Şube";
    const iban = settings?.iban || "TR00 0000 0000 0000 0000 0000 00";
    const receiver = settings?.aliciAdi || "ResLife Medikal";

    const note1 = settings?.servisNotu1 || "Azami tamir süresi 20 iş günüdür.";
    const note2 = settings?.servisNotu2 || "90 gün içerisinde teslim alınmayan cihazlardan firmamız mesul değildir.";
    const note3 = settings?.servisNotu3 || "Müşteri, cihazını teslim ederken formda belirtilen arızaları ve şartları kabul etmiş sayılır.";

    const gridStyle = {
        width: '100%',
        borderTop: '1px solid #000',
        borderLeft: '1px solid #000',
        '& .MuiGrid-item': {
            borderRight: '1px solid #000',
            borderBottom: '1px solid #000',
            p: 0.8, // Increased padding slightly
            display: 'flex',
            alignItems: 'center'
        }
    };

    const labelStyle = {
        fontWeight: 'bold',
        bgcolor: '#f0f0f0',
        height: '100%'
    };

    return (
        <>
            <style type="text/css" media="print">
                {`
                @page { size: auto; margin: 5mm; }
                body { visibility: hidden; }
                #technical-service-form { visibility: visible; position: absolute; left: 0; top: 0; width: 100%; }
                #technical-service-form * { visibility: visible; }
                `}
            </style>
            <Box sx={{
                display: 'none',
                '@media print': {
                    display: 'block',
                    p: 2,
                    fontFamily: 'Arial, sans-serif',
                    fontSize: '12px', // Base font küçültüldü - tek sayfa optimizasyonu
                    color: '#000',
                    backgroundColor: '#fff',
                    maxWidth: '100%',
                    boxSizing: 'border-box'
                }
            }} id="technical-service-form">

                {/* Header */}
                <Box sx={{ mb: 1 }}>
                    <Grid container sx={gridStyle}>
                        <Grid item xs={3} sx={{ justifyContent: 'center' }}>
                            <img src={logoUrl} alt="Logo" style={{ maxWidth: '100%', maxHeight: '80px', objectFit: 'contain' }} />
                        </Grid>
                        <Grid item xs={5} sx={{ flexDirection: 'column', textAlign: 'center', justifyContent: 'center' }}>
                            <Typography sx={{ fontWeight: 'bold', fontSize: '20px' }}>{companyName}</Typography>
                            <Typography sx={{ fontSize: '12px' }}>{subTitle1}</Typography>
                            <Typography sx={{ fontSize: '12px' }}>{subTitle2}</Typography>
                            <Typography sx={{ fontSize: '12px' }}>{address}</Typography>
                            <Typography sx={{ fontSize: '12px' }}>Tel: {phone} | {web}</Typography>
                        </Grid>
                        <Grid item xs={4} sx={{ flexDirection: 'column', p: '4px !important' }}>
                            <Typography sx={{ fontWeight: 'bold', textAlign: 'center', fontSize: '16px', mb: 0.5, width: '100%' }}>TEKNİK SERVİS FORMU</Typography>
                            <Box sx={{ textAlign: 'center', mb: 0.5, width: '100%' }}>
                                {serviceRecord.serviceNo && (
                                    <Typography sx={{ fontSize: '16px', fontWeight: 'bold', color: '#d32f2f' }}>
                                        Servis No: {String(serviceRecord.serviceNo).padStart(6, '0')}
                                    </Typography>
                                )}
                                {serviceRecord.isSgk && (
                                    <Box sx={{ border: '1px solid #000', display: 'inline-block', px: 1, mt: 0.5 }}>
                                        <Typography sx={{ fontSize: '14px', fontWeight: 'bold' }}>SGK ZİMMETLİ CİHAZ</Typography>
                                    </Box>
                                )}
                                {serviceRecord.cihazHurdada && (
                                    <Box sx={{ border: '2px solid red', display: 'inline-block', px: 1, mt: 0.5, bgcolor: '#ffebee' }}>
                                        <Typography sx={{ fontSize: '14px', fontWeight: 'bold', color: 'red' }}>⚠️ CİHAZ HURDADA</Typography>
                                    </Box>
                                )}
                            </Box>
                            <Box sx={{ fontSize: '12px', width: '100%' }}>
                                <Grid container spacing={0}>
                                    <Grid item xs={6} sx={{ borderRight: '1px solid #ddd !important', borderBottom: 'none !important', pr: 0.5 }}>
                                        <Box><b>Teslim Alma:</b> {formatDate(serviceRecord.teslimAlmaTarihi || serviceRecord.olusturmaTarihi)}</Box>
                                    </Grid>
                                    <Grid item xs={6} sx={{ borderBottom: 'none !important', borderRight: 'none !important', pl: 0.5 }}>
                                        <Box><b>Teslim Etme:</b> {formatDate(serviceRecord.teslimTarihi)}</Box>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>

                {/* Device & Customer Info */}
                <Box sx={{ mb: 1 }}>
                    <Grid container sx={gridStyle}>
                        {/* Row 1 */}
                        <Grid item xs={2} sx={labelStyle}>Cihaz Sınıfı</Grid>
                        <Grid item xs={4}>{serviceRecord.cihazSinifi || deviceInfo?.cihazSinifi || '-'}</Grid>
                        <Grid item xs={2} sx={labelStyle}>Marka</Grid>
                        <Grid item xs={4}>{serviceRecord.cihazMarka || serviceRecord.cihazMarkaModel?.split(' ')[0]}</Grid>

                        {/* Row 2 */}
                        <Grid item xs={2} sx={labelStyle}>Model</Grid>
                        <Grid item xs={4}>{serviceRecord.cihazModel || serviceRecord.cihazMarkaModel?.split(' ').slice(1).join(' ')}</Grid>
                        <Grid item xs={2} sx={labelStyle}>Seri No</Grid>
                        <Grid item xs={4}>{serviceRecord.cihazSeriNumarasi}</Grid>

                        {/* Row 3 - Customer */}
                        <Grid item xs={2} sx={labelStyle}>Müşteri / Firma</Grid>
                        <Grid item xs={4}>{serviceRecord.musteriAdSoyad}</Grid>
                        <Grid item xs={2} sx={labelStyle}>TC Kimlik No</Grid>
                        <Grid item xs={4}>{customer?.tcKimlikNo || '-'}</Grid>

                        {/* Row 4 - Contact */}
                        <Grid item xs={2} sx={labelStyle}>Telefon</Grid>
                        <Grid item xs={4}>{serviceRecord.musteriTelefon}</Grid>
                        <Grid item xs={2} sx={labelStyle}>E-Posta</Grid>
                        <Grid item xs={4}>{customer?.email || '-'}</Grid>

                        {/* Row 5 - Technical Data */}
                        <Grid item xs={2} sx={labelStyle}>Bakım Türü</Grid>
                        <Grid item xs={4}>{serviceRecord.bakimTuru || '-'}</Grid>
                        <Grid item xs={2} sx={labelStyle}>Oksijen Oranı</Grid>
                        <Grid item xs={4}>{(serviceRecord.oksijenOrani !== null && serviceRecord.oksijenOrani !== undefined && serviceRecord.oksijenOrani !== '') ? `%${serviceRecord.oksijenOrani}` : '-'}</Grid>

                        <Grid item xs={2} sx={labelStyle}>Basınç Değeri</Grid>
                        <Grid item xs={4}>{serviceRecord.basincDegeri ? (isNaN(serviceRecord.basincDegeri) ? serviceRecord.basincDegeri : `${serviceRecord.basincDegeri} mbar`) : '-'}</Grid>

                        <Grid item xs={2} sx={labelStyle}>Çalışma Süresi</Grid>
                        <Grid item xs={4}>{serviceRecord.calismaSuresi || '-'}</Grid>
                    </Grid>
                </Box>

                {/* Findings & Actions */}
                <Box sx={{ mb: 1 }}>
                    <Box sx={{ border: '1px solid #000', borderBottom: 'none', p: 0.5, bgcolor: '#f0f0f0', fontSize: '14px', fontWeight: 'bold', textAlign: 'center' }}>Tespit ve İşlem Detayları</Box>
                    <Grid container sx={gridStyle}>
                        <Grid item xs={2} sx={labelStyle}>Müşteri Şikayeti</Grid>
                        <Grid item xs={10}>{serviceRecord.arizaTanimi}</Grid>

                        <Grid item xs={2} sx={labelStyle}>Yapılan İşlemler</Grid>
                        <Grid item xs={10}>{serviceRecord.yapilanIslemler}</Grid>

                        <Grid item xs={2} sx={labelStyle}>Açıklama</Grid>
                        <Grid item xs={10}>{serviceRecord.servisNotlari || '-'}</Grid>
                    </Grid>
                </Box>

                {/* Parts Table */}
                <Box sx={{ mb: 1, borderTop: '1px solid #000', borderLeft: '1px solid #000' }}>
                    <Table size="small" sx={{
                        '& .MuiTableCell-root': {
                            borderRight: '1px solid #000',
                            borderBottom: '1px solid #000',
                            padding: '6px', // Increased padding
                            fontSize: '13px', // Increased font
                            color: '#000',
                            borderLeft: 'none',
                            borderTop: 'none'
                        }
                    }}>
                        <TableHead>
                            <TableRow sx={{ bgcolor: '#f0f0f0' }}>
                                {/* Parça Kodu removed */}
                                <TableCell sx={{ fontWeight: 'bold' }}>Parça / Hizmet Adı</TableCell>
                                <TableCell align="right" sx={{ fontWeight: 'bold', width: '60px' }}>Miktar</TableCell>
                                <TableCell align="right" sx={{ fontWeight: 'bold', width: '100px' }}>Birim Fiyat</TableCell>
                                <TableCell align="right" sx={{ fontWeight: 'bold', width: '100px' }}>Tutar</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {serviceRecord.kullanilanParcalar?.map((item, index) => (
                                <TableRow key={index}>
                                    <TableCell>{item.ad || item.aciklama}</TableCell>
                                    <TableCell align="right">{item.miktar}</TableCell>
                                    <TableCell align="right">{(item.birimFiyat || 0).toFixed(2)}</TableCell>
                                    <TableCell align="right">{(item.toplamFiyat || 0).toFixed(2)}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    {/* Totals Section - Independent border structure */}
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', borderRight: '1px solid #000', borderBottom: '1px solid #000' }}>
                        <Box sx={{ width: '300px' }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', p: 1, bgcolor: '#fff' }}>
                                <Typography sx={{ fontSize: '16px', fontWeight: 'bold' }}>GENEL TOPLAM (KDV Hariç)</Typography>
                                <Typography sx={{ fontSize: '16px', fontWeight: 'bold' }}>{(serviceRecord.toplamTutar || 0).toFixed(2)} ₺</Typography>
                            </Box>
                        </Box>
                    </Box>
                </Box>

                {/* Notes - Tek nota indirildi */}
                <Box sx={{ fontSize: '10px', mb: 1, mt: 1 }}>
                    <Typography sx={{ fontSize: '10px' }}>* {note1}</Typography>
                </Box>

                {/* Signatures */}
                <Grid container spacing={4} sx={{ mt: 2 }}>
                    <Grid item xs={6}>
                        <Box sx={{ borderTop: '1px solid #000', pt: 1, textAlign: 'center' }}>
                            <Typography sx={{ fontSize: '13px', fontWeight: 'bold' }}>Servise Teslim Alan</Typography>
                            <Typography sx={{ fontSize: '12px' }}>{companyName}</Typography>
                            <Box sx={{ height: '50px' }} />
                            <Typography sx={{ fontSize: '12px' }}>İmza</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={6}>
                        <Box sx={{ borderTop: '1px solid #000', pt: 1, textAlign: 'center' }}>
                            <Typography sx={{ fontSize: '13px', fontWeight: 'bold' }}>Servisi Teslim Eden/Müşteri</Typography>
                            <Typography sx={{ fontSize: '12px' }}>{serviceRecord.musteriAdSoyad}</Typography>
                            <Box sx={{ height: '50px' }} />
                            <Typography sx={{ fontSize: '12px' }}>İmza</Typography>
                        </Box>
                    </Grid>
                </Grid>

                {/* Bank Info kaldırıldı - tek sayfa optimizasyonu */}

            </Box>
        </>
    );
};

export default TechnicalServiceForm;
